import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Problems() {
  return (
    <section className="intro_section p-100">
      <Container>
        <Row>
          <Col xs={12} md={12} lg={5} xl={5} xxl={5} className="my-auto ">
            <h2 style={{ color: "#000" }}>
              The <span style={{ color: "#207146" }}>Problem</span>
            </h2>
            <p>
              The challenge for this project was to integrate a wide range of
              community building, networking and ecommerce features into the
              application. This included the ability to live broadcast sermons,
              cope with heavy network traffic and server loads, and carry out
              secure online transactions pertaining to church merchandise.
            </p>
          </Col>
          <Col
            xs={12}
            md={12}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto text-center offset-lg-1 "
          >
            <StaticImage
              src="../../../images/case-studies/true-wine/problem_img.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={708}
              height={592}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Problems;
